<template>
    <div class='my-area' :id='titleData.title'>
        <div class='area-title'>
            <Icon :type='titleData.icon' class='icon'></Icon>
            <span>{{titleData.title}}</span>
        </div>
        <my-card v-for='item in areaData' :cardData='item' :key='item.id'></my-card>
    </div>
</template>
<style>
    .my-area {
        padding: 20px 0 10px 0;
    }

    .area-title {
        height: 30px;
        line-height: 30px;
        font-size: 15px;
        text-align: center;
        width: 120px;
        background: white;
        border: 1px solid #dddee1;
        margin-bottom: 10px;
    }

    .icon {
        margin-right: 10px;
    }
</style>
<script>
    import MyCard from '../../../components/card.vue'
    export default {
        props: [
            'areaData',
            'titleData',
        ],
        components: {
            MyCard
        }
    }

</script>


// WEBPACK FOOTER //
// my-area.vue?7d0da959